import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SaleOrderPaymentService from "../../Controller/SaleOrderPaymentController";
import CreateSaleOrderPayment from "./CreateSaleOrderPayment";
import HelpSite from "../../../Common/HelpLink";
import SaleOrderService from "../../Controller/SaleOrderController";
function SaleOrderPaymentPage({ SaleOrderID }) {
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    SaleOrderID = localStorage.getItem('SaleOrderID');


    const [SaleOrderPaymentList, setSaleOrderPayment] = useState([]);

    const [modalInstance, setModalInstance] = useState(null);
    const [currentSaleOrderPayment, setCurrentSaleOrderPayment] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isClosed, SetIsClosed] = useState("0");
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const fetchSaleOrderPayment = async () => {
        try {
            const data = await SaleOrderPaymentService.GetAllSaleOrderPayment(redirectCallback, SaleOrderID);
            setSaleOrderPayment(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };
    const fetchSaleOrderDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (SaleOrderID > 0) {
                const saleOrderDetail = await SaleOrderService.GetSaleOrderByID(redirectCallback, SaleOrderID);
                const saleOrder = saleOrderDetail[0];
                if (saleOrder.bit_DropShipment > 0 || saleOrder.bit_DropShipmentc > 0) {
                    SetIsClosed("1");
                }
            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    useEffect(() => {
        SetIsClosed("0");
        fetchSaleOrderDetail();
        fetchSaleOrderPayment();
    }, [SaleOrderID]);

    const handleCreateSaleOrderNotesClick = () => {
        setCurrentSaleOrderPayment(null);
        fetchSaleOrderPayment();
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEditClick = (payment) => {
        setCurrentSaleOrderPayment(payment);
        fetchSaleOrderPayment();
        setIsModalOpen(true);
    };
    const handleSuccess = () => {
        fetchSaleOrderPayment();// Refresh the list after submission
        handleCloseModal();   // Close the modal
    };

    const handleDeleteClick = async (ID, redirectCallback) => {
        const confirmed = window.confirm("Are you sure you want to delete this contact?");
        if (confirmed) {
            try {
                await SaleOrderPaymentService.DeleteSaleOrderPayment(ID, redirectCallback);
                fetchSaleOrderPayment(); // Refresh the list after deletion
            } catch (error) {
                console.error('Error deleting Contact:', error);
            }
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-3">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateSaleOrderNotesClick} disabled={isClosed === '1' || isClosed === 1}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">
                    <div className="">
                        <table className="table m-0 table-hover">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Amount</th>
                                    <th>Method</th>
                                    <th>Reference</th>
                                    <th style={{ "textAlign": "right" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {SaleOrderPaymentList.map((payment) => (
                                    <tr key={payment.PK_SalesOrderPayment_ID} onClick={() => handleEditClick(payment)} disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                                        <td>{formatDate(payment.dt_PaymentDate)}</td>
                                        <td>{payment.mon_Amount}</td>
                                        <td>{payment.snt_PaymentType}</td>
                                        <td>{payment.Reference}</td>


                                        <td style={{ "textAlign": "right" }}>

                                            <button style={{ "background": "none", "border": "none" }} className="text-danger" onClick={() => handleDeleteClick(payment.PK_SalesOrderPayment_ID)} disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                                                <i className="icofont-ui-delete" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <CreateSaleOrderPayment
                    modalInstance={modalInstance}
                    currentSaleOrderPayment={currentSaleOrderPayment}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}

                    SaleOrderID={SaleOrderID}


                />
            )}
        </div>
    );
}

export default SaleOrderPaymentPage;
